import { render, staticRenderFns } from "./FulfillmentPage.vue?vue&type=template&id=5779dc36&scoped=true"
import script from "./FulfillmentPage.vue?vue&type=script&lang=js"
export * from "./FulfillmentPage.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentPage.vue?vue&type=style&index=0&id=5779dc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779dc36",
  null
  
)

export default component.exports